import React from "react";
import { Search } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Switch } from "./ui/switch";

export function MinutesFilters({ f, setF }) {
  const { data: filters } = useApi("/meetings/minutes/filters");
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  return (
    <div className="mb-4 grid gap-2 md:grid-cols-[1fr_auto_auto_auto]" data-testid="minutes-search-bar">
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input value={f.q} onChange={(e) => set("q")(e.target.value)} placeholder="Search decisions, motions, keywords…" className="pl-9" data-testid="minutes-search-input" />
      </div>
      <Select value={f.eventId} onValueChange={set("eventId")}>
        <SelectTrigger className="min-w-[180px]" data-testid="minutes-meeting-filter"><SelectValue placeholder="All meetings" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All meetings</SelectItem>
          {(filters?.meetings || []).map((e) => <SelectItem key={e.id} value={e.id}>{e.title}{e.date ? ` (${e.date})` : ""}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={f.year} onValueChange={set("year")}>
        <SelectTrigger className="min-w-[120px]" data-testid="minutes-year-filter"><SelectValue placeholder="All years" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All years</SelectItem>
          {(filters?.years || []).map((y) => <SelectItem key={y} value={y}>{y}</SelectItem>)}
        </SelectContent>
      </Select>
      <label className="flex min-h-[40px] items-center gap-2 text-sm"><Switch checked={f.adopted} onCheckedChange={set("adopted")} data-testid="minutes-adopted-toggle" /> Adopted only</label>
    </div>
  );
}
